import { PlaceholderPage } from '../PlaceholderPage'

export function GlobalCoinSummaryPage() {
  return <PlaceholderPage title="Global coin summary" legacyComponent="StatisticsGlobalCoinSummaryComponent" />
}
